import React, {Component} from "react";
import TipStyle from "./style";


//局部loading   小loading
class PartLoading extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    };


    componentDidMount() {
    };


    render() {

        return (
            <div>
                局部 loading
            </div>
        )
    }
}


export default PartLoading;
